import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchReplaceArticle } from "@coworker/app/src/components/TestBuy/CommonComponents/Repositories/testbuy.article.api";
import {
  useMyStore,
  useStoreId,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { TestBuyProductWithCriteria } from "@coworker/types/lib/testbuy";

export const useReplaceItem = (testbuyId: string, activeArticleId: string) => {
  const storeId: string = useStoreId();
  const store = useMyStore();
  const [userLanguage] = useUserPreference(
    profilePreferences.LANGUAGE,
    store?.primaryLocale
  );
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newArticleId: string) => {
      return await fetchReplaceArticle(
        testbuyId,
        activeArticleId,
        newArticleId,
        userLanguage,
        storeId
      );
    },
    onSuccess: (data) => {
      // this will update the specific article in the testbuy articles list
      queryClient.setQueryData(
        ["get-testbuy-articles", testbuyId],
        (prevItems: TestBuyProductWithCriteria[]) =>
          prevItems.map((prevItem: TestBuyProductWithCriteria) =>
            prevItem.shortId === activeArticleId
              ? { ...prevItem, ...data }
              : prevItem
          )
      );
    },
  });
};
